"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
// 스피너 애니메이션 정의
const spin = (0, styled_components_1.keyframes) `
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
// 로딩 오버레이 스타일 정의
const LoadingOverlay = styled_components_1.default.div `
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 999;
	display: flex;
	justify-content: center;
	align-items: center;

	.background {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #000;
		opacity: 0.5;
	}
`;
// 스피너 스타일 정의
const Spinner = styled_components_1.default.div `
	border: 30px solid ${props => `var(--color-tur, #3AB2BF)`};
	border-top: 30px solid ${props => `var(--color-dark_tur, #479DA6)`};
	border-radius: 50%;
	width: 120px;
	height: 120px;
	animation: ${spin} 2s linear infinite;
	position: absolute;
	z-index: 4;
`;
const LoadingPage = ({ defaultLoading = false }) => {
    const [isShow, setIsShow] = react_1.default.useState(true);
    const handlerLoading = (isLoading) => {
        setIsShow(isLoading);
    };
    (0, react_1.useEffect)(() => {
        setIsShow(defaultLoading);
    }, [defaultLoading]);
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('SHOW_LOADING', handlerLoading);
        return () => {
            APP.eventManager.unsubscribe('SHOW_LOADING', handlerLoading);
        };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null, isShow && (react_1.default.createElement(LoadingOverlay, null,
        react_1.default.createElement("div", { className: "background" }),
        react_1.default.createElement(Spinner, null)))));
};
exports.default = LoadingPage;
